import { useCallback } from 'react';
import { graphql } from 'react-relay';

import { useWriteFragmentInterop } from '@confluence/apollo-relay-interop/entry-points/useWriteFragmentInterop.ts';

import type {
	useSetSpaceViewsSortTransientWriteFragment$data,
	SpaceViewsPersistenceOption,
} from './__generated__/useSetSpaceViewsSortTransientWriteFragment.graphql.ts';
import spaceViewsSortTransientWriteFragmentArtifact from './__generated__/useSetSpaceViewsSortTransientWriteFragment.graphql.ts';

// Switches the space content view for the current session only by writing the cache fragment that
// @confluence/space-views reads from, without the updateUserPreferences mutation (reverts on reload).
// Kept local rather than importing from @confluence/space-views, which would form a dependency cycle.
export const useSetSpaceViewsSortTransient = (spaceKey?: string) => {
	const writeFragmentInterop = useWriteFragmentInterop<
		Omit<useSetSpaceViewsSortTransientWriteFragment$data, ' $fragmentType'>
	>({
		fragmentArtifact: spaceViewsSortTransientWriteFragmentArtifact,
		fragmentSpec: graphql`
			fragment useSetSpaceViewsSortTransientWriteFragment on UserPreferences {
				spaceViewsPersistence(spaceKey: $spaceKey)
				__typename
			}
		`,
	});

	return useCallback(
		(newSort: SpaceViewsPersistenceOption): void => {
			writeFragmentInterop({
				fragmentId: `$ROOT_QUERY.userPreferences`,
				data: {
					spaceViewsPersistence: newSort,
					__typename: 'UserPreferences',
				},
				variables: { spaceKey },
			});
		},
		[spaceKey, writeFragmentInterop],
	);
};
